const errorAudioUrl = require("@/assets/audio/error.wav");
const successAudioUrl = require("@/assets/audio/success.mp3");
const branch_does_not_match_url = require("@/assets/audio/Branch_does_not_match.mp3");
const doorAudioUrl = require("@/assets/audio/door.mp3");

function sing(type) {
    let audio;
    if(type == 'success') {
        audio = successAudioUrl;
    } else if(type == 'error') {
        audio = errorAudioUrl;
    } else if(type == 'does_not_match') {
        audio = branch_does_not_match_url;
    } else if(type == 'door') {
        audio = doorAudioUrl;
    }
    const song = new Audio(audio);
    if(type == 'does_not_match') {
        song.playbackRate = 1.3;
    }
    song.play();
}

export {
    sing,
}